<template>
    <span class="icon icon_info">
        <svg
            class="on"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5ZM17.5866 9.14869C17.8919 8.86868 17.9123 8.39424 17.6323 8.08901C17.3523 7.78378 16.8779 7.76333 16.5726 8.04334L10.4345 13.6742L7.42662 10.915C7.12139 10.6349 6.64695 10.6554 6.36694 10.9606C6.08693 11.2659 6.10738 11.7403 6.41261 12.0203L9.92747 15.2447C10.2143 15.5078 10.6547 15.5078 10.9415 15.2447L17.5866 9.14869Z"
                  :fill="color"/>

        </svg>
        <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="off"
        >
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M5 4.5H19C19.2761 4.5 19.5 4.72386 19.5 5V19C19.5 19.2761 19.2761 19.5 19 19.5H5C4.72386 19.5 4.5 19.2761 4.5 19V5C4.5 4.72386 4.72386 4.5 5 4.5ZM3 5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5ZM17.2198 9.39452C17.525 9.11451 17.5455 8.64008 17.2655 8.33485C16.9854 8.02961 16.511 8.00916 16.2058 8.28917L10.5475 13.4798L7.79354 10.9534C7.4883 10.6734 7.01387 10.6938 6.73386 10.9991C6.45385 11.3043 6.4743 11.7787 6.77953 12.0587L10.0405 15.0503C10.3273 15.3134 10.7677 15.3134 11.0545 15.0503L17.2198 9.39452Z"
                  :fill="color"/>

        </svg>
    </span>
</template>

<script lang="ts">
export default {
    name: 'IconCheckSquare',
    props: {
        color: {
            type: String,
            default: '#1a1a1a',
        },
    },
};
</script>

<style scoped lang="scss">
.icon_info {
    display: inline-block;
    vertical-align: middle;
    font-size: 0;
    width: 24px;
    height: 24px;

    svg {
        width: 100%;
        height: 100%;
    }

    &.on {
        .on {
            display: block;
        }

        .off {
            display: none;
        }
    }

    &:not(.on) {
        .on {
            display: none;
        }

        .off {
            display: block;
        }
    }
}
</style>
